import { useCallback } from "react";
import { KanaDrawCounts } from "../utils/kanaDrawCountsStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useKanaDrawCounts() {
    const { data: counts, update, syncStatus, cloudLoadFailed } = useDeviceProgress<KanaDrawCounts>("kanaDrawCounts", true);
    const increment = useCallback((key: string) => { void update({ kind: "increment", key }); }, [update]);
    return { counts, increment, syncStatus, cloudLoadFailed };
}
